import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "subscription-header" }
const _hoisted_2 = { class: "subscription-header-left" }
const _hoisted_3 = { class: "subscription-avatar" }
const _hoisted_4 = {
  key: 1,
  class: "subscription-avatar-text"
}
const _hoisted_5 = { class: "subscription-header-copy" }
const _hoisted_6 = { class: "subscription-name" }
const _hoisted_7 = { class: "subscription-meta-line" }
const _hoisted_8 = { class: "subscription-status" }
const _hoisted_9 = { class: "status-text" }
const _hoisted_10 = { class: "subscription-body" }
const _hoisted_11 = { class: "subscription-details" }
const _hoisted_12 = { class: "subscription-details-left" }
const _hoisted_13 = { class: "subscription-detail-row" }
const _hoisted_14 = { class: "subscription-detail-row" }
const _hoisted_15 = { class: "text-success" }

import AppCard from "@/shared/components/ui/AppCard.vue";
import { formatCurrency, formatDate, getStatusColor, getTextColor } from "@/shared/utils/utils";

type SubscriptionStatus = "Active" | "Paused" | "Inactive" | "All";

interface SubscriptionItem {
  id: string | number;
  packageName: string;
  planAmount: number | null;
  billingInterval: string;
  nextBillingDate: string | null;
  status: SubscriptionStatus;
  vendorName: string;
  vendorLogo: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionListCard',
  props: {
    item: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function vendorInitials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "subscription-card",
    role: "button",
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.item.vendorLogo)
            ? (_openBlock(), _createBlock(_component_v_avatar, {
                key: 0,
                size: "40"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: __props.item.vendorLogo,
                    alt: __props.item.vendorName || __props.item.packageName || 'Vendor avatar',
                    cover: ""
                  }, null, 8, ["src", "alt"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(vendorInitials(__props.item.vendorName || __props.item.packageName || "SU")), 1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.item.packageName || "Subscription"), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(__props.item.vendorName || "Unknown vendor"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", {
          class: _normalizeClass(["status-dot", `status-dot--${__props.item.status.toLowerCase()}`])
        }, null, 2),
        _createElementVNode("span", _hoisted_9, _toDisplayString(__props.item.status), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_icon, {
              size: "16",
              class: "subscription-detail-icon"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("mdi-currency-usd", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", null, _toDisplayString(__props.item.planAmount != null ? _unref(formatCurrency)(__props.item.planAmount) : "-") + " /" + _toDisplayString(__props.item.billingInterval || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_icon, {
              size: "16",
              class: "subscription-detail-icon"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-calendar-sync-outline", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("span", null, [
              _cache[3] || (_cache[3] = _createTextVNode(" Next Billing : ", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(__props.item.nextBillingDate ? _unref(formatDate)(__props.item.nextBillingDate) : "-"), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})